import styled from 'styled-components';

export const StyledTicketsPage = styled.main`
  position: relative;
  width: 100%;
`;
